module.exports = __webpack_public_path__ + "img/Screen-L@2x.306bcd22.png";